import { PlatformMaintenanceState } from './platformMaintenance.state'

export const initialState: PlatformMaintenanceState = {
    loading: false,
    startDate: '',
    endDate: '',
}
